var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.clickQrFileButton}},[_c('img',{attrs:{"src":_vm.util.getImagePath('browse_img_white@2x.png'),"srcset":_vm.util.getImageSet('browse_img_white')}}),_vm._v(" "),_c('input',{ref:"qrFileInput",staticStyle:{"display":"none"},attrs:{"type":"file","name":"image","accept":"image/*"},on:{"change":_vm.onChangeInput}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f8c1138","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QrcodeCapture.vue
// module id = null
// module chunks = 